if (!customElements.get('adev-personalization')) {
    customElements.define('adev-personalization', class adevPersonalization extends HTMLElement {
        constructor() {
            super();

            this.heartIcon = `♡`;
            this.maxCharacters = 7
            ;
            
            this.isPersonalizationEnabled = false;
            this.selectedColor = 'Pink';
            this.includeHeart = false;
            this.rawText = '';
        }

        updatedProductInfoHtml(html) {
            html.querySelectorAll('[data-adev-price]').forEach((priceEl) => {
                const priceValue = parseInt(priceEl.dataset.adevPrice) || 0;
                const priceString = priceEl.dataset.adevPriceString || '';

                const price = this.getPrice();

                const totalPrice = priceValue + price;

                if (priceString.includes('[money]')) {
                    priceEl.innerHTML = priceString.replace('[money]', Shopify.formatMoney(totalPrice));
                } else {
                    priceEl.innerHTML = Shopify.formatMoney(totalPrice);
                }
            });

            return html;
        }

        isActive() {
            return this.isPersonalizationEnabled;
        }

        getPrice() {
            if (!this.isPersonalizationEnabled) {
                return 0;
            }

            return parseInt(this.dataset.price) || 0;
        }

        validate() {
            if (!this.isPersonalizationEnabled) {
                return true;
            }

            const colors = ['Pink', 'Light Blue', 'Black', 'White'];
            if (!colors.includes(this.selectedColor)) {
                return 'Please select a valid color for personalization.';
            }

            if (!this.rawText || this.rawText.trim() === '') {
                return 'Please enter text for personalization.';
            }

            if (this.rawText.length > this.maxCharacters) {
                return `Personalization text cannot exceed ${this.maxCharacters} characters.`;
            }

            return true;
        }

        getProductId() {
            return this.dataset.productId;
        }

        getParentProdudctId() {
            return this.dataset.parentId;
        }

        initForm() {
            const mainProductEl = this.closest('[data-section-name="main-product"]');

            const formEl = mainProductEl.querySelector('product-form form');

            this.productIdEl = document.createElement('input');
            this.productIdEl.type = 'hidden';
            this.productIdEl.name = 'items[1][id]';
            this.productIdEl.value = this.dataset.productId;
            this.productIdEl.disabled = true;

            formEl.appendChild(this.productIdEl);

            this.productIdUniqueEl = document.createElement('input');
            this.productIdUniqueEl.type = 'hidden';
            this.productIdUniqueEl.name = 'items[1][properties][_adev_is_personalized]';
            this.productIdUniqueEl.value = this.dataset.productId + '---' + Date.now();
            this.productIdUniqueEl.disabled = true;

            formEl.appendChild(this.productIdUniqueEl);
            
            this.personalizationInputEl = document.createElement('input');
            this.personalizationInputEl.type = 'hidden';
            this.personalizationInputEl.name = 'properties[Personalisierung]';
            this.personalizationInputEl.value = 'Ja';
            this.personalizationInputEl.disabled = true;

            formEl.appendChild(this.personalizationInputEl);

            this.colorInputEl = document.createElement('input');
            this.colorInputEl.type = 'hidden';
            this.colorInputEl.name = 'properties[Personalisierungsfarbe]';
            this.colorInputEl.value = '';
            this.colorInputEl.disabled = true;

            formEl.appendChild(this.colorInputEl);

            this.textInputEl = document.createElement('input');
            this.textInputEl.type = 'hidden';
            this.textInputEl.name = 'properties[Personalisierungstext]';
            this.textInputEl.disabled = true;
            this.textInputEl.maxLength = 7;
            this.textInputEl.required = true;

            formEl.appendChild(this.textInputEl);

            this.includeHeartInputEl = document.createElement('input');
            this.includeHeartInputEl.type = 'hidden';
            this.includeHeartInputEl.name = 'properties[Herz hinzufügen]';
            this.includeHeartInputEl.value = this.includeHeart ? 'Ja' : 'Nein';
            this.includeHeartInputEl.disabled = true;

            formEl.appendChild(this.includeHeartInputEl);
        }

        destroyForm() {
            if (this.productIdEl) {
                this.productIdEl.remove();
                this.productIdEl = null;
            }

            if (this.productIdUniqueEl) {
                this.productIdUniqueEl.remove();
                this.productIdUniqueEl = null;
            }

            if (this.personalizationInputEl) {
                this.personalizationInputEl.remove();
                this.personalizationInputEl = null;
            }

            if (this.colorInputEl) {
                this.colorInputEl.remove();
                this.colorInputEl = null;
            }

            if (this.textInputEl) {
                this.textInputEl.remove();
                this.textInputEl = null;
            }

            if (this.includeHeartInputEl) {
                this.includeHeartInputEl.remove();
                this.includeHeartInputEl = null;
            }

        }

        enableFormInputs() {
            if (this.productIdEl) {
                this.productIdEl.disabled = false;
                this.productIdUniqueEl.disabled = false;
            }

            if (this.personalizationInputEl) {
                this.personalizationInputEl.disabled = false;
            }

            if (this.colorInputEl) {
                this.colorInputEl.disabled = false;
            }

            if (this.textInputEl) {
                this.textInputEl.disabled = false;
            }

            if (this.includeHeartInputEl) {
                this.includeHeartInputEl.disabled = false;
            }
        }

        disableFormInputs() {
            if (this.productIdEl) {
                this.productIdEl.disabled = true;
                this.productIdUniqueEl.disabled = true;
            }

            if (this.personalizationInputEl) {
                this.personalizationInputEl.disabled = true;
            }

            if (this.colorInputEl) {
                this.colorInputEl.disabled = true;
            }

            if (this.textInputEl) {
                this.textInputEl.disabled = true;
            }

            if (this.includeHeartInputEl) {
                this.includeHeartInputEl.disabled = true;
            }
        }

        updateFormInputs() {
            if (this.personalizationInputEl) {
                this.personalizationInputEl.value = this.isPersonalizationEnabled ? 'Ja' : '';
            }

            if (this.colorInputEl) {
                this.colorInputEl.value = this.selectedColor;
            }

            if (this.textInputEl) {
                this.textInputEl.value = this.rawText + (this.includeHeart ? this.heartIcon : '');
            }
            
            if (this.includeHeartInputEl) {
                this.includeHeartInputEl.value = this.includeHeart ? 'Ja' : 'Nein';
            }
        }


        onCheckChange(event) {
            const isChecked = event.target.checked;
            const inputs = this.querySelectorAll('[data-adev-personalization-input]');

            inputs.forEach((input) => {
                input.disabled = !isChecked;
            });
            

            this.isPersonalizationEnabled = isChecked;

            const mainEl = this.querySelector('[data-adev-personalization="main"]');
            if (mainEl) {
                mainEl.classList.toggle('is--active', isChecked);
            }

            this.classList.toggle('is--active', isChecked);

            if (isChecked) {
                this.enableFormInputs();
            } else {
                this.disableFormInputs();
            }

            this.updateFormInputs();
            
            const mainProductEl = this.closest('[data-section-name="main-product"]');
            if (mainProductEl) {
                this.updatedProductInfoHtml(mainProductEl);
            }
        }

        initCheckEl() {
            const checkEl = this.querySelector('[data-adev-personalization="check"]');

            if (checkEl) {
                this.onCheckChangeBound = this.onCheckChange.bind(this);
                checkEl.addEventListener('change', this.onCheckChangeBound);
            }
        }

        destroyCheckEl() {
            if (this.onCheckChangeBound) {
                const checkEl = this.querySelector('[data-adev-personalization="check"]');
                if (checkEl) {
                    checkEl.removeEventListener('change', this.onCheckChangeBound);
                }
                this.onCheckChangeBound = null;
            }
        }

        onColorChange(event) {
            const selectedColor = event.target.value;
            this.selectedColor = selectedColor;

            console.log('Selected Color:', this.selectedColor);

            this.updateFormInputs();
        }

        initColorInputs() {
            const colorInputs = this.querySelectorAll('[data-adev-personalization="color-input"]');
            this.onColorChangeBound = this.onColorChange.bind(this);

            colorInputs.forEach((input) => {
                input.addEventListener('change', this.onColorChangeBound);
            });
        }

        destroyColorInputs() {
            if (this.onColorChangeBound) {
                const colorInputs = this.querySelectorAll('[data-adev-personalization="color-input"]');
                colorInputs.forEach((input) => {
                    input.removeEventListener('change', this.onColorChangeBound);
                });
                this.onColorChangeBound = null;
            }
        }



        updateTextInputCounter(textInput) {
            const counterEl = this.querySelector('[data-adev-personalization="text-input-counter"]');
            if (counterEl) {
                counterEl.textContent = `${textInput.value.length} / ${textInput.maxLength}`;
            }
        }

        onTextInput(event) {
            const textInput = event.target;

            const caretPosition = textInput.selectionStart;
            let value = textInput.value;

            if (this.includeHeart && value.endsWith(this.heartIcon)) {
                value = value.slice(0, -1);
            } else if (!this.includeHeart) {
                value = value.replace(this.heartIcon, '');
            }

            if (value.length > this.maxCharacters) {
                value = value.slice(0, this.maxCharacters);
            }

            this.rawText = value;
            this.rawText = this.rawText.replace(this.heartIcon, '');

            const suffix = this.includeHeart ? this.heartIcon : '';
            const displayValue = this.rawText + suffix;

            textInput.value = displayValue;

            // Restore caret position
            const newCaretPosition = Math.min(caretPosition, displayValue.length);
            textInput.setSelectionRange(newCaretPosition, newCaretPosition);

            this.updateTextInputCounter(textInput);

            this.updateFormInputs();
        }

        initTextInput() {
            const textInput = this.querySelector('[data-adev-personalization="text-input"]');
            if (textInput) {
                this.onTextInputBound = this.onTextInput.bind(this);
                textInput.addEventListener('input', this.onTextInputBound);
            }
        }

        destroyTextInput() {
            if (this.onTextInputBound) {
                const textInput = this.querySelector('[data-adev-personalization="text-input"]');
                if (textInput) {
                    textInput.removeEventListener('input', this.onTextInputBound);
                }
                this.onTextInputBound = null;
            }
        }

        onIncludeHeartChange(event) {
            const isChecked = event.target.checked;
            this.includeHeart = isChecked;

            this.rawText = this.rawText.replace(this.heartIcon, '');

            if (this.rawText.length > this.maxCharacters) {
                this.rawText = this.rawText.slice(0, this.maxCharacters);
            }

            const textInput = this.querySelector('[data-adev-personalization="text-input"]');
            if (textInput) {
                const suffix = this.includeHeart ? this.heartIcon : '';

                if (this.includeHeart && this.rawText.length >= this.maxCharacters) {
                    this.rawText = this.rawText.slice(0, this.maxCharacters - 1);
                }

                const displayValue = this.rawText + suffix;
                textInput.value = displayValue;

                this.updateTextInputCounter(textInput);
            }

            this.updateFormInputs();
        }

        initIncludeHeart() {
            const checkEl = this.querySelector('[data-adev-personalization="include-heart"]');
            if (checkEl) {
                this.onIncludeHeartChangeBound = this.onIncludeHeartChange.bind(this);
                checkEl.addEventListener('change', this.onIncludeHeartChangeBound);
            }
        }

        destroyIncludeHeart() {
            if (this.onIncludeHeartChangeBound) {
                const checkEl = this.querySelector('[data-adev-personalization="include-heart"]');
                if (checkEl) {
                    checkEl.removeEventListener('change', this.onIncludeHeartChangeBound);
                }
                this.onIncludeHeartChangeBound = null;
            }
        }

        connectedCallback() {
            this.initForm();

            this.initCheckEl();
            this.initColorInputs();
            this.initTextInput();
            this.initIncludeHeart();
        }

        disconnectedCallback() {
            this.destroyCheckEl();
            this.destroyColorInputs();
            this.destroyTextInput();
            this.destroyIncludeHeart();
        }

    });
}